import { Button, Table, message } from "antd";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";
import { useNavigate } from "react-router";
import apiCall from "../../../components/Api";
import FilterOptions from "../../../components/Common/antdFilterOptions";
import StatusComponent from "../../../components/Common/StatusComponent";
import UploadExcel from "../../../components/Common/uploadExcel";
import AddButton from "../../../components/Common/addButton";
import Breadcrumbs from "../../../components/Common/Breadcrumbs/AntdBreadcrumbs";
import Pagination from "../../../components/Common/CommonPagination/index";
import MainconternLayout from "../../../components/Layout/MainconternLayout";
import NavBarTitles from "../../../components/Common/TabBar";
import ExcelDownloadModal from "../../../Pages/Masters/Common/excelDownloadAccess";
import { MoleculeBreadcrumbsList, navBarData } from "../Const";
import scroll from "../../../assets/webp/scroll.webp";

const SaltMolecules = () => {
  const navigate = useNavigate();
  const [pages, setPages] = useState(0);
  const [skip, setSkip] = useState(0);
  const [limit, setLimit] = useState(10);
  const [sort, setSort] = useState("newest");
  const [records, setRecords] = useState([]);
  const [count, setCount] = useState(0);
  const [showPopup, setShowPopup] = useState(false);
  const [deleteModal, setDeleteModal] = useState({ id: "", status: false });
  const [searchText, setSearchText] = useState("");
  const [alphabet, setAlphabet] = useState("#");
  const [letters, setLetters] = useState([]);
  const [medicineCounts, setMedicineCounts] = useState({});
  const [loader, setLoader] = useState(true);

  const fetchMedicineCount = async (id) => {
    if (medicineCounts[id] !== undefined) return;

    try {
      const response = await apiCall(`medicine/get-medicine/${id}`, "GET");
      setMedicineCounts((prevCounts) => ({
        ...prevCounts,
        [id]: response.data.count,
      }));
    } catch (error) {
      console.error("Error fetching medicine count:", error);
    }
  };

  useEffect(() => {
    list_api_call();
  }, [limit, sort, skip, searchText, alphabet, count]);

  const handlePageChange = (event) => {
    setSkip(event.selected * limit);
  };

  const list_api_call = async () => {
    try {
      const response = await apiCall(`salt-molecule/list`, "POST", {
        skip: skip,
        limit: Number(limit),
        sort: sort,
        searchText,
        populateMedicineCount: true,
        alphabet: alphabet === "#" ? "" : alphabet,
      });
      setRecords(response.data.records);
      setCount(response.data.count);
      setPages(Math.ceil(response.data.count / limit));
    } catch (err) {
      console.error(err);
      alert("Some error");
    }
  };

  const handleAdd = () => {
    navigate("/healthsy-services/order-medicines/masters/salt-molecules-form");
  };

  const handleEdit = (id) => {
    navigate(
      `/healthsy-services/order-medicines/masters/salt-molecules-form-edit/${id}`,
    );
  };

  const handleDelete = async (id) => {
    try {
      await apiCall(
        `salt-molecule/delete/${deleteModal?.id}`,
        "DELETE",
        null,
        null,
      );
      list_api_call();
      setDeleteModal({ id: "", status: false });
      message.success("Item deleted successfully");
      // handleDelete(id);
    } catch (error) {
      setDeleteModal({ id: "", status: false });
      message.error("Failed to delete item");
    }
  };

  const handleActive = async (id, status) => {
    try {
      await apiCall(
        `salt-molecule/update/${id}`,
        "PATCH",
        { active: !status },
        null,
      );
      list_api_call();
      message.success("Status updated successfully");
    } catch (error) {
      message.error("Failed to update status");
    }
  };

  const columns = [
    {
      title: "S.No",
      render: (text, record, index) => Number(skip || 0) + (index + 1),
      key: "serial",
      width: 80,
      fixed: "left",
    },
    {
      title: "Status & Actions",
      render: (text, record) => (
        <StatusComponent
          text={text}
          record={record}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
          handleEdit={handleEdit}
          setDeleteModal={setDeleteModal}
          handleActive={handleActive}
          title={"molecule_name"}
        />
      ),
      key: "actions",
      width: 170,
      fixed: "left",
    },
    {
      title: "Salt / Molecule Name",
      dataIndex: "name",
      key: "name",
      width: 450,
      render: (text, record) => (
        <span className="">{record.molecule_name}</span>
      ),
      fixed: "left",
    },
    {
      title: "Therapeutic Classification",
      dataIndex: "therapeutic_classification",
      key: "therapeutic_classification",
      width: 350,
      ellipsis: true,
      render: (text, record) => (
        <span className="">{record.therapeutic_classification}</span>
      ),
    },
    {
      title: "Total Medicines Containing Molecule",
      dataIndex: "total_medicine_containing_molecule",
      key: "total_medicine_containing_molecule",
      width: 70,
      ellipsis: true,
      render: (text, record) => {
        fetchMedicineCount(record._id);

        return (
          <>
            {medicineCounts[record._id] !== undefined ? (
              <Button
                onClick={() =>
                  navigate(
                    `/healthsy-services/order-medicines/masters/salt-molecule/${record._id}/view-medicines`,
                  )
                }
              >
                View {medicineCounts[record._id]} Medicines
              </Button>
            ) : (
              <span>-</span>
            )}
          </>
        );
      },
    },
  ];

  const handleSortClick = (selectedSort) => {
    setSort(selectedSort);
  };
  const debouncedSearch = debounce((value) => {
    handlePageChange({ selected: 0 });
    setSearchText(value);
  }, 500);

  const onChangeSearch = (value) => {
    debouncedSearch(value);
  };

  useEffect(() => {
    async function fetchLetters() {
      try {
        const result = await apiCall("salt-molecule/get-alphabets", "GET");
        if (result)
          setLetters(() => {
            result?.data.unshift("#");
            return result?.data;
          });
      } catch (err) {
        console.error("Error fetching letters", err);
      }
    }

    fetchLetters();
  }, [count]);

  useEffect(() => {
    records.length > 0 && setTimeout(() => setLoader(false));
  }, [records]);

  return (
    <>
      <MainconternLayout
        header={
          <div className="d-flex pb-2 flex-wrap align-items-center justify-content-between">
            <Breadcrumbs
              className="healthsyMasterBreadCrumbs"
              breadcrumbsList={MoleculeBreadcrumbsList("list")}
            />
            <div className="d-flex gap-4 align-items-center">
              <div className="bgPrimary addBtn">
                <AddButton
                  onClick={handleAdd}
                  addBtn={true}
                  btnContent="Add Salt / Molecule"
                />
              </div>
              <UploadExcel
                apiUrl="salt-molecule/create-bulk"
                list_api_call={list_api_call}
              />
            </div>
          </div>
        }
        footer={
          <div className="mt-4 col d-flex align-items-center pagination justify-content-between admin-pagination">
            <div className="border border-danger bg-bg-light px-2 py-1 rounded">
              {" "}
              Total Salt/Molecules: {count}
            </div>
            {count >= limit && (
              <Pagination
                skip={skip}
                limit={limit}
                total={pages * limit}
                onPageChange={(selected) => handlePageChange({ selected })}
              />
            )}
          </div>
        }
      >
        <div className="healtharticle-container healthsyContainer">
          <NavBarTitles titles={navBarData} />
          <FilterOptions
            limit={limit}
            handleSortClick={handleSortClick}
            setLimit={setLimit}
            filterBy={false}
            onChangeSearch={onChangeSearch}
          />
          {count > 0 && (
            <div className="d-flex saltMoleculesAlphabetsWrapper">
              {letters?.map((letter, inx) => (
                <div
                  key={inx}
                  className={`cursor-pointer ${
                    alphabet === letter
                      ? "saltMoleculeUncheck"
                      : "saltMoleculeAlphabets"
                  } saltMoleculeLetters flexRow justify-content-center align-items-center`}
                  onClick={() => setAlphabet(letter)}
                >
                  {letter}
                </div>
              ))}
              {alphabet.length > 0 && alphabet !== "#" && (
                <IoCloseCircleOutline
                  size={24}
                  onClick={() => setAlphabet("")}
                />
              )}
            </div>
          )}
          {!loader ? (
            <Table
              columns={columns}
              dataSource={records}
              pagination={false}
              rowKey="_id"
              className="mx-3 pt-2 table-scrollable moleculeList_table"
              // style={{ maxHeight: "calc(100vh - 400px)" }}
              scroll={{ x: "max-content" }}
            />
          ) : (
            <div className="d-flex justify-content-center">
              <img src={scroll} width={150} alt="loader" />
            </div>
          )}
        </div>
      </MainconternLayout>
      {deleteModal.status === true && (
        <ExcelDownloadModal
          onClickDownload={handleDelete}
          isModalOpen={deleteModal.status}
          title={`Delete '${deleteModal?.molecule_name}' Confirmation`}
          desc="Note: Medicine records also deleted related with this salt/molecule. To proceed with delete, please enter your username and password below"
          setIsModalOpen={(status) => setDeleteModal({ id: "", status })}
          confirmBtnText="Delete"
          forDelete={true}
        />
      )}
    </>
  );
};

export default SaltMolecules;
